import {configureStore} from '@reduxjs/toolkit';
import SensoresReducer from './reducers/meteorologico';
import RiegoReducer from './reducers/riego';
import TeslaReducer from './reducers/tesla';
import SueloReducer from './reducers/suelo';
import AguaDulceReducer from './reducers/aguaDulce';
import AguaSaladaReducer from './reducers/aguaSalada';
import EntornoReducer from './reducers/entorno';
import SensoresReducerNodo from './reducers/meteorologicoNodo';
import RiegoReducerNodo from './reducers/riegoNodo';
import SueloReducerNodo from './reducers/sueloNodo';
import TeslaReducerNodo from './reducers/teslaNodo';
import AguaDulceReducerNodo from './reducers/aguaDulceNodo';
import AguaSaladaReducerNodo from './reducers/aguaSaladaNodo';
import EntornoReducerNodo from './reducers/entornoNodo';
import CoordenadasReducer from './reducers/coordenadas';
import UltimoDulceReducerNodo from './reducers/ultimoDulce'
import UltimoSaladaReducerNodo from './reducers/ultimoSalada'
import UltimoRiegoReducerNodo from './reducers/ultimoRiego'
import UltimoMeteorologicoReducerNodo from './reducers/ultimoMeteorologico'
import UltimoEntornoReducerNodo from './reducers/ultimoEntorno'
import UltimoSueloReducerNodo from './reducers/ultimoSuelo'
import UltimoTeslaReducerNodo from './reducers/ultimoTesla'

export const store = configureStore({
    reducer: {
        meteorologico: SensoresReducer,
        riego: RiegoReducer,
        tesla: TeslaReducer,
        suelo: SueloReducer,
        dulce: AguaDulceReducer,
        salada: AguaSaladaReducer,
        entorno: EntornoReducer,
        meteorologicoNodo: SensoresReducerNodo,
        riegoNodo: RiegoReducerNodo,
        teslaNodo: TeslaReducerNodo,
        sueloNodo: SueloReducerNodo,
        dulceNodo: AguaDulceReducerNodo,
        saladaNodo: AguaSaladaReducerNodo,
        entornoNodo: EntornoReducerNodo,
        coordenadas: CoordenadasReducer,
        ultimoDulce: UltimoDulceReducerNodo,
        ultimoSalada: UltimoSaladaReducerNodo,
        ultimoMeteorologico: UltimoMeteorologicoReducerNodo,
        ultimoEntorno: UltimoEntornoReducerNodo,
        ultimoRiego: UltimoRiegoReducerNodo,
        ultimoSuelo: UltimoSueloReducerNodo,
        ultimoTesla: UltimoTeslaReducerNodo
    }
})